import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import Home from "./Home";
import OneTimePayment from "./OneTimePayment";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/payment" element={<Home />} />
        <Route path="/one-time-payment" element={<OneTimePayment />} />
        <Route
          path="/mobile"
          element={
            <Navigate to={`/?${window.location.search.slice(1)}`} replace />
          }
        />
      </Routes>
    </Router>
  );
};

export default App;
